import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Grid, Typography } from "@mui/material";

import "../../../../assets/styles/numeracy-question.css";
import Image from '../../../ui-components/Image';

export default function Numeracy({ question, onAnswer = () => {} }) {
	const theme = useTheme();
	const [answer, setAnswer] = React.useState([]);

	React.useEffect(() => {
		// reset proceed button
		setAnswer([]);
	}, [question]);

	const handleSetAnswer = (value) => {
		let newAnswer,
			canProceed = false;
		if (question.questionTotalAnswer === 1) {
			newAnswer = value;
			canProceed = value !== "";
		} else {
			newAnswer = [...answer];
			if (answer.indexOf(value) !== -1) {
				newAnswer = answer.filter((a) => a !== value);
			} else {
				newAnswer.push(value);
			}

            canProceed = newAnswer.length > 0;
            if (question.questionTotalAnswer) {
			    canProceed = question.questionTotalAnswer === newAnswer.length;
            }
		}
		setAnswer(newAnswer);

		onAnswer({
			canProceed,
			answer: newAnswer,
		});
	};
	return (
		<React.Fragment>
			<Box
				className="choices-container"
				sx={{ px: 4, textAlign: "center" }}
			>
				{question.questionList.map((q, k) => (
					<Grid
						container
						sx={{ mt: 2 }}
						key={`mc-id-${k}-${Math.random()}`}
					>
						<Grid
							item
							sm={12}
							xs={12}
							className={
								"mc-question-container " +
								(answer.indexOf(q.value) >= 0 ? "active" : "")
							}
							onClick={() => {
								handleSetAnswer(q.value);
							}}
						>
							<Image
								src={`clipart/${q.image}`}
								alt={q.label}
								style={{ width: "5rem" }}
                                skeletonHeight="5rem"
                                skeletonWidth="5rem"
							/>{" "}
							<Typography
								sx={{
									color: theme.palette.primary.main,
									fontWeight: "bold",
								}}
							>
								{q.label}
							</Typography>
						</Grid>
					</Grid>
				))}
			</Box>
		</React.Fragment>
	);
}
